import * as ApiRequests from '../../api/requests';
import { AuthHelper } from '../../types/auth-helper-types';
import { AppThunk } from '../actions';

import { GetOrgActions } from '../actions/get-org-type-action';
export const GetOrgTypeThunks = {
    GetOrgCheckDetails: (
        GetOrgData: {
            organizationId: string;
        },
        authHelper: AuthHelper,
        addToast: Function
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(GetOrgActions.getOrgCheckStarted());

        const payload = await ApiRequests.getOrganizationType(
            {
                organizationId: GetOrgData.organizationId,
            },
            { authHelper }
        );

        if (payload.ok) {
            dispatch(
                GetOrgActions.getOrgCheckSucceeded(
                    // payload.response.message,
                    payload.response.data
                )
            );
        } else {
            const errorCode = ApiRequests.extractResponseNotOkCode(payload.response);
            if (errorCode) {
                addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
            }
            dispatch(GetOrgActions.getOrgCheckFailed(errorCode.toString()));
        }
    },
};
